module.exports = __webpack_public_path__ + "static/Wight-9391468d4ca0668647db4e328a82f17c.jpg";